import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  Outlet,
} from 'react-router-dom';

import Login from './Pages/Login';
import Purchase from './Pages/Purchase';
import Sales from './Pages/Sales';
import MainLayout from './Pages/MainLayout';
import Home from './Pages/Home';
import ReceiptPayment from './Pages/ReceiptPayment';
import CashFLow from './Pages/CashFlow';
import StockValuation from './Pages/StockValuation';
import BudgetVsActua from './Pages/BudgetVsActua';
import PayablesReceivables from './Pages/PayablesReceivables';
import LotWiseDetails from './Pages/LotWiseDetails';
import GSTR2B from './Pages/Gst_Reco';
import GSTRECO1stTABLE from './Pages/Gst_1stTable';
import GstRecoQuarter from './Pages/Gst_RecoQuarter'; // Create this file

import { useMsal } from '@azure/msal-react';
import MicrosoftLoginRedirect from './Pages/Auth/MicrosoftLoginRedirect'; // Create this file
import TDSReport from './Pages/TDSReport';
import PurchaseCapitalExpenditure from './Pages/PurchaseCapitalExpenditure';
import AccountVerification from './Pages/AccountVerification';
import TallyImportdata from './Pages/TallyImportdata';
import PurchaseTracking from './Pages/PurchaseTracking';
import WagesCalculator from './Pages/WagesCalculator';
import AxisBankAutomation from './Pages/AxisBankAutomation';

const isLocalhost = window.location.hostname === 'localhost';

// const ProtectedRoute = () => {
//   const isAuthenticated = sessionStorage.getItem('auth') === 'true';
//   const location = useLocation();
//   return isAuthenticated ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
// };

// 🔒 Step 1: Wrapper to protect routes (after both MS + PIN login)
const ProtectedRoute = () => {
  const { accounts } = useMsal();
  const location = useLocation();

  const pinAuthenticated = sessionStorage.getItem('auth') === 'true';
  const msAuthenticated = accounts.length > 0 || sessionStorage.getItem("msalLogin") === "true";

  const isLocalhost = window.location.hostname === 'localhost';
  const isAuthenticated = isLocalhost ? pinAuthenticated : pinAuthenticated && msAuthenticated;

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={isLocalhost ? "/login" : "/auth"} state={{ from: location }} replace />
  );
};

// Step 2: Show PIN screen only after MS login on production
const PinGate = () => {
  const { accounts } = useMsal();
  const location = useLocation();

  const isMicrosoftLoggedIn = accounts.length > 0 || sessionStorage.getItem("msalLogin") === "true";

  return isMicrosoftLoggedIn ? (
    <Login />
  ) : (
    <Navigate to="/auth" state={{ from: location }} replace />
  );
};



// const ProtectedRoute = () => {
//   const { accounts } = useMsal();
//   const location = useLocation();

//   const pinAuthenticated = sessionStorage.getItem('auth') === 'true';
//   const msAuthenticated = accounts.length > 0;

//   // In development, skip MS login check
//   const isAuthenticated = isLocalhost ? pinAuthenticated : pinAuthenticated && msAuthenticated;

//   return isAuthenticated ? (
//     <Outlet />
//   ) : (
//     <Navigate to={isLocalhost ? "/login" : "/auth"} state={{ from: location }} replace />
//   );
// };


// 🔐 Step 2: Route guard for showing PIN only after MS login
// const PinGate = () => {
//   const { accounts } = useMsal();
//   const isMicrosoftLoggedIn = accounts.length > 0;
//   const location = useLocation();

//   return isMicrosoftLoggedIn ? (
//     <Login />
//   ) : (
//     <Navigate to="/auth" state={{ from: location }} replace />
//   );
// };


const AutoLogout = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;
    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        sessionStorage.removeItem('auth');
        navigate('/login');
      }, 900000); // 15 minutes
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    resetTimer();

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [navigate]);

  return children;
};

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<Login />} />

//         {/* 🔐 Protected Route Wrapper */}
//         <Route element={<ProtectedRoute />}>
//           <Route
//             path="/"
//             element={
//               <AutoLogout>
//                 <MainLayout />
//               </AutoLogout>
//             }
// ✅ Main App Component
function App() {
  return (
    <Router>
      <Routes>
        {/* 🔁 Microsoft Auth Redirect Trigger */}
        <Route path="/auth" element={<MicrosoftLoginRedirect />} />

        {/* 🔒 PIN Login Only After MS Login */}
        {/* <Route path="/login" element={<PinGate />} /> */}
        <Route
            path="/login"
            element={
              isLocalhost ? <Login /> : <PinGate />
            }
          />
        {/* 🔐 Secure Routes */}
        <Route element={<ProtectedRoute />}>
          <Route
            path="/"
            element={
              <AutoLogout>
                <MainLayout />
              </AutoLogout>
            }
          >
            <Route path="home" element={< Home/>} />
            <Route path="purchase" element={<Purchase />} />
            <Route path="sales" element={<Sales />} />
            <Route path='Receipt-Payment' element={<ReceiptPayment/>}/>
            <Route path='Cash-Flow' element={<CashFLow/>}/>
            <Route path='Stock-Valuation' element={<StockValuation/>}/>
            <Route path='Budget-Vs-Actua' element={<BudgetVsActua/>}/>
            <Route path='Payables-Receivables' element={<PayablesReceivables/>}/>
            <Route path='lot-wise-details' element={<LotWiseDetails/>}/>
            <Route path='GST-RECO-1st' element={<GSTRECO1stTABLE/>}/>
            <Route path='Purchase-Capital-Expenditure' element={<PurchaseCapitalExpenditure/>}/>
            <Route path='TDS-Report' element={<TDSReport/>}/>
            <Route path='Account-Verification' element={<AccountVerification/>}/>
            <Route path='Purchase-Tracking' element={<PurchaseTracking/>}/>
          </Route>
          <Route path='GST-RECO' element={<GSTR2B/>}/>
          <Route path='GST-RECO-Quarter' element={<GstRecoQuarter/>}/>
          <Route path="Tally-Import-Data" element={<TallyImportdata />} />
          <Route path="wages-calculation" element={<WagesCalculator />} />
          <Route path="/axis-automation" element={<AxisBankAutomation />} />
        </Route>  
          
      </Routes>
    </Router>
  );
}

export default App;
